<template lang='pug'>
  v-btn(color='accent' :large='large' dark :id="`get-started-${bionicmetricsId}`" @click='goToRequestDemo()')
    | {{label}}

</template>

<script>
import router from '../router';

export default {
  name: 'RequestTrialButton',
  data() {
    return {
      email: '', comments: '', beLink: false, beLarge: false
    };
  },
  props: {
    bionicmetricsId: {type: String},
    large: {type: Boolean},
    label: {
      type: String,
      default: 'Get Started'
    }
  },
  methods: {
    goToRequestDemo() {
      if (!document.querySelector('#requestTrialSection')) router.push('/request-demo');
      else this.$vuetify.goTo('#requestTrialSection');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
